import React from "react";
import SportsCricketIcon from "@material-ui/icons/SportsCricket";
import PoolIcon from "@material-ui/icons/Pool";
import SaveIcon from "@material-ui/icons/Save";
import Button from "@material-ui/core/Button";
import ProfileImage from "../images/Profile.png";

function Profile() {
  return (
    <>
      <div id="Profile" className="banner">
        <div className="row top-container">
          <div className="col-lg-2 col-md-2 col-sm-12 col-12"></div>
          <div className="col-lg-8 col-md-8 col-sm-12 col-12">
            <h1 id="Name" className="text-center title">
              Hello, I'm Chetan.
            </h1>
            <div className="text-center">
              <img
                alt="profile"
                className="profile-img"
                src={ProfileImage}
              ></img>
            </div>
            <p className="intro">
              My name is Chetan Birmole, I am Currently working in Accenture as
              Application Development Analyst with 4 years of experience in
              Front-End development. I love Cricket <SportsCricketIcon /> and
              Swimming <PoolIcon />
            </p>
            <div className="icons-div text-center mb-2">
              <i class="fab top-icons fa-html5"></i>
              <i class="fab top-icons fa-css3-alt"></i>
              <i class="fab top-icons fa-js"></i>
              <i class="fab top-icons fa-react"></i>
              <i class="fab top-icons fa-node-js"></i>
              <i class="fab top-icons fa-bootstrap"></i>
              <br />
              <Button
                variant="contained"
                color="default"
                size="large"
                className="mt-3"
                startIcon={<SaveIcon />}
                onClick={() => {
                  window.open(
                    "https://drive.google.com/file/d/1NS3EBBZDX6HKanXgFHkp43OyH8_r_mjz/view?usp=sharing"
                  );
                }}
              >
                Resume
              </Button>
            </div>
            <div className="arrow">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
          <div className="col-lg-2 col-md-2 col-sm-12 col-12"></div>
        </div>
      </div>
      <hr className="m-0" />
    </>
  );
}

export default Profile;
